import { StepAction } from './stepAction';
import { extractElementId } from '../../utils';
import { KEY_MAP } from '../utils/stepActionUtils';
import type { SpecialKeyStep } from 'clickim/src/common/models/specialKeyStep';

export class SpecialKeyStepAction extends StepAction<SpecialKeyStep> {
    private setWithValueApi(keys: string[]) {
        const target = this.getTarget();
        if (target?.seleniumElement) {
            return this.driver.elementIdValue(extractElementId(target.seleniumElement), keys);
        }
        return Promise.reject(new Error('missing selenium element'));
    }

    override performAction() {
        const keys = [];
        const keyCode = this.step.events![0].eventData.keyCode;

        if (keyCode >= 32 && keyCode <= 127) {
            keys.push(String.fromCharCode(keyCode));
        } else {
            keys.push(KEY_MAP[keyCode as keyof typeof KEY_MAP]);
        }
        return this.setWithValueApi(keys);
    }
}
